import {StateList} from "./StateList";
import {StateEdit} from "./StateEdit";
import {StateCreate} from "./StateCreate";

export default {
    list: StateList,
    create: StateCreate,
    edit: StateEdit
};
